export default {
  title: "Définissez votre projet d'investissement",
  sections: {
    fillInformations: {
      title: 'Complétez les informations',
      investmentHorizonSubSectionTitle: "Horizon d'investissement",
      investmentHorizonSubSectionSubtitle:
        "Définir un horizon d'investissement pour cette opération :",
      investmentHorizonInputTitle: "Horizon d'investissement",
      investmentHorizonInputPlaceholder: 'Sélectionner',
      footerHelpText:
        "Les choix suivants vont permettre d'affiner notre préconisation financière",

      scheduledContributionsSubSection: {
        title: 'Vos versements',
        description:
          'Configurer vos versements à effectuer lors de cette opération',
        inputLabel: 'Versements programmés',
        inputPlaceholder: 'Saisissez un montant mensuel',
        inputError: {
          valueTooMuch: 'La capacité d\'épargne disponible est de {amount}',
        },
      },
    },
  },
}
